import * as yup from 'yup';

export const headerQuickAddValidation = yup.object({
    qty1: yup.string().when(`item1`, {is: (value) => value, then: yup.string().required(`Qty Required`)}),
    qty2: yup.string().when(`item2`, {is: (value) => value, then: yup.string().required(`Qty Required`)}),
    qty3: yup.string().when(`item3`, {is: (value) => value, then: yup.string().required(`Qty Required`)}),
    qty4: yup.string().when(`item4`, {is: (value) => value, then: yup.string().required(`Qty Required`)}),
});
